import Vue from 'vue'
// import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'

Vue.mixin({
    computed : {
        ...mapGetters({
            user : 'user',
        }),
    },
    methods: {
        can(permissionName) {
            return _.get(this.user, 'can',[]).indexOf(permissionName) !== -1;
        },
        hasRole(roleName) {
            return _.get(this.user, 'role_names',[]).indexOf(roleName) !== -1;
        },
    },
});